import { motion } from 'framer-motion'
import { useImagePixels } from './useImagePixels'
import { COLORS } from './ui'

const G = 14

// Hero: a grid of pixels assembling into the reference image — sets the theme
// (an image IS a grid of numbers) on contact, instead of a generic galaxy.
export function Hero2D() {
  const pixels = useImagePixels('/cv/ref-cat.png', G, G)

  return (
    <div style={{
      position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', overflowY: 'auto',
      alignItems: 'center', justifyContent: 'center', gap: 26, padding: 24,
      fontFamily: "'General Sans', system-ui, sans-serif", textAlign: 'center', color: COLORS.text,
    }}>
      <div style={{
        display: 'grid', gridTemplateColumns: `repeat(${G}, 1fr)`, gap: 2,
        width: 196, height: 196, opacity: 0.9,
      }}>
        {(pixels || Array.from({ length: G * G }, () => [40, 40, 70])).map(([r, g, b], i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, scale: 0.3 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: (i % G) * 0.02 + Math.floor(i / G) * 0.02, duration: 0.5 }}
            style={{ background: `rgb(${r},${g},${b})`, borderRadius: 2 }}
          />
        ))}
      </div>

      <div>
        <div style={{ overflow: 'hidden', padding: '0.08em 0' }}>
          <motion.h1
            initial={{ y: '110%' }}
            animate={{ y: '0%' }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            style={{
              fontFamily: "'Clash Display', 'General Sans', sans-serif",
              fontSize: 'clamp(40px, 7vw, 84px)', fontWeight: 700, margin: 0, lineHeight: 1.0,
              letterSpacing: '-0.03em',
              background: 'linear-gradient(92deg, #f1f5f9 20%, #818cf8 92%)',
              WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
            }}>
            How Computers See
          </motion.h1>
        </div>
        <p style={{
          marginTop: 14, fontSize: 13, letterSpacing: '0.22em', textTransform: 'uppercase',
          color: COLORS.indigoLight, fontFamily: "'JetBrains Mono', ui-monospace, monospace",
        }}>
          A visual journey through computer vision · 2026
        </p>
      </div>

      <motion.div
        animate={{ y: [0, 8, 0], opacity: [0.4, 0.8, 0.4] }}
        transition={{ duration: 2, repeat: Infinity }}
        style={{ fontSize: 11, letterSpacing: '0.2em', color: COLORS.textFaint, fontFamily: "'JetBrains Mono', ui-monospace, monospace" }}
      >
        SCROLL TO BEGIN ↓
      </motion.div>
    </div>
  )
}
